// カードスクロール用 composable
import { ref, nextTick } from "vue";

type ScrollTarget = {
  getBoundingClientRect: () => DOMRect;
  scrollIntoView: (options?: ScrollIntoViewOptions) => void;
};

type ComponentRef = { $el?: ScrollTarget } | ScrollTarget | null | undefined;

const isScrollTarget = (value: ComponentRef): value is ScrollTarget => {
  return Boolean(
    value
      && typeof (value as ScrollTarget).getBoundingClientRect === "function"
      && typeof (value as ScrollTarget).scrollIntoView === "function"
  );
};

export function useCorrectionCardScroll() {
  const cardRefs = ref<Record<number, ComponentRef>>({});

  function registerCardRef(suggestionId: number | null | undefined, componentRef: ComponentRef) {
    if (!suggestionId) return;
    if (componentRef) {
      cardRefs.value[suggestionId] = componentRef;
    } else {
      delete cardRefs.value[suggestionId];
    }
  }

  function scrollSelectedCardIntoView(selectedSuggestionId: number | null | undefined) {
    if (!selectedSuggestionId) return;
    const componentRef = cardRefs.value[selectedSuggestionId];
    if (!componentRef) return;
    const element = isScrollTarget(componentRef) ? componentRef : componentRef.$el;
    if (!element) return;

    nextTick(() => {
      const rect = element.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const fullyVisible = rect.top >= 0 && rect.bottom <= viewportHeight;
      if (fullyVisible) return;
      element.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  }

  return {
    cardRefs,
    registerCardRef,
    scrollSelectedCardIntoView,
  };
}
